var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49767 2.49915H3.33233C2.87224 2.49915 2.49927 2.87212 2.49927 3.33221V9.16368C2.49927 9.62377 2.87224 9.99675 3.33233 9.99675H7.49767C7.95776 9.99675 8.33073 9.62377 8.33073 9.16368V3.33221C8.33073 2.87212 7.95776 2.49915 7.49767 2.49915Z",
    stroke: "#F0E1CE",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6612 2.49915H12.4959C12.0358 2.49915 11.6628 2.87212 11.6628 3.33221V5.83141C11.6628 6.2915 12.0358 6.66448 12.4959 6.66448H16.6612C17.1213 6.66448 17.4943 6.2915 17.4943 5.83141V3.33221C17.4943 2.87212 17.1213 2.49915 16.6612 2.49915Z",
    stroke: "#F0E1CE",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6612 9.99683H12.4959C12.0358 9.99683 11.6628 10.3698 11.6628 10.8299V16.6614C11.6628 17.1214 12.0358 17.4944 12.4959 17.4944H16.6612C17.1213 17.4944 17.4943 17.1214 17.4943 16.6614V10.8299C17.4943 10.3698 17.1213 9.99683 16.6612 9.99683Z",
    stroke: "#F0E1CE",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49767 13.3291H3.33233C2.87224 13.3291 2.49927 13.7021 2.49927 14.1622V16.6614C2.49927 17.1215 2.87224 17.4944 3.33233 17.4944H7.49767C7.95776 17.4944 8.33073 17.1215 8.33073 16.6614V14.1622C8.33073 13.7021 7.95776 13.3291 7.49767 13.3291Z",
    stroke: "#F0E1CE",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDash);
export default __webpack_public_path__ + "static/media/dash.1915f9cc3c0baf30549ef9af90757671.svg";
export { ForwardRef as ReactComponent };